// Do we need a selectors file? Or is this more of a util?
export const getLocaleFromSettings = (settings = {}) => {
  const { user: { default_locale: locale } = {} } = settings;
  return locale;
};

export const getLocaleFromGon = (gon = {}) => {
  const {
    current_user: { settings: { default_locale: locale } = {} } = {}
  } = gon;
  return locale;
};

export default getLocaleFromSettings;
